import { makeStyles } from '@material-ui/core'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useGlobalState } from '../store'

const useStyle = makeStyles({
  root: {
    backgroundColor: '#FECE2F40',
    color: '#EAB625',
    border: '1px solid #EAB625',
    borderRadius: 16,
    width: 'fit-content',
    padding: 12,
    fontWeight: 900,
    paddingTop: 4,
    paddingBottom: 4,
    fontSize: 13,
    display: 'inline-block',
    whiteSpace: 'nowrap',
  },
})

const ChipCategory = ({ domaineId }) => {
  const [categories] = useGlobalState('categories')

  const classes = useStyle()

  const domain = categories.list?.find((d) => d._id === domaineId)

  if (!!domain.part) return null

  // Display only if this is a pro category only
  return (
    <div className={classes.root}>
      <FormattedMessage id={'ChipCategory.Enterprise'} defaultMessage={'Compte Entreprise'} />{' '}
    </div>
  )
}

export default ChipCategory
